import React, { useContext } from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';
import Authentication from '../Authentication';
import CartBannerWidget from '../cart/CartBannerWidget';
import config from '../../../config';

const ENV_CONFIG = config.get();

const buildLinksForUser = ({ User, handleLoginClick, logoutMutation }) => {
  let links = [];
  if (_.get(User, 'data.username')) {
    links.push(
      <li key="logout">
        {User.data.username}
        <a onClick={logoutMutation.mutate}>
          <i className="fi-eject" />
          Log out
        </a>
      </li>,
    );
    /*
    links.push(
      <li key="profile">
        <Link to="/app/profile">
          <i className="fi-address-book" />
          Profile
        </Link>
      </li>
    )*/
  } else {
    if (ENV_CONFIG.loginEnabled) {
      links.push(
        <li key="login">
          <a onClick={handleLoginClick}>
            <i className="fi-torso" />
            Log in
          </a>
        </li>,
      );
    }
  }
  if (_.get(User, 'data.isAdmin')) {
    links.push(
      <li key="admin">
        <Link to="/app/admin">
          <i className="fi-lock" />
          Admin Dashboard
        </Link>
      </li>,
    );
  }
  links.push(<CartBannerWidget key="cart" />);
  return links;
};

const User = () => (
  <Authentication.Consumer>
    {({ User, LoginModalRendered, handleLoginClick, logoutMutation }) => {
      return (
        <div>
          {LoginModalRendered}
          <ul className="menu dropdown">
            <li className="site-nav--contact__mobile show-for-small-only">
              <p>
                <i className="fi-mail"></i>
                <a href="mailto:customerservice@mountainvalleygrowers.com">
                  Email us
                </a>
              </p>
            </li>
            {buildLinksForUser({ User, handleLoginClick, logoutMutation })}
          </ul>
        </div>
      );
    }}
  </Authentication.Consumer>
);

export default User;
